var React = require('react');

function SendInline (props) {
    return React.createElement("svg",props,[React.createElement("g",{"opacity":"0.5","clipPath":"url(#clip0_583_12576)","key":0},[React.createElement("path",{"d":"M14.6666 1.33398L7.33325 8.66732","stroke":"white","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M14.6666 1.33398L9.99992 14.6673L7.33325 8.66732L1.33325 6.00065L14.6666 1.33398Z","stroke":"white","strokeWidth":"1.2","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_583_12576"},React.createElement("rect",{"width":"16","height":"16","fill":"white"})))]);
}

SendInline.defaultProps = {"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none"};

module.exports = SendInline;

SendInline.default = SendInline;
